import api from '../../plugins/api';

// ÐÑÐ¾Ð²ÐµÑÐºÐ° Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð¼Ð°ÑÐºÐ¸ Ð¿ÐµÑÐµÐ´ Ð¸Ð¼Ð¿Ð¾ÑÑÐ¾Ð¼: ÑÐºÐ¾Ð»ÑÐºÐ¾ Ð¼Ð°ÑÐ¸Ð½ Ð¾ÑÐ´Ð°ÑÑ ÐÐ¸ÑÑÐ¸ÐºÑ, ÐºÐ°ÐºÐ¸Ðµ Ð¿Ð¾Ð»Ñ
// Ð½Ð°ÑÐ»Ð¸ÑÑ Ð¿Ð¾ Ð¿Ð¾Ð´Ð¿Ð¸ÑÑÐ¼, ÐºÐ°ÐºÐ¸Ðµ ÐÐ¦ Ð½Ðµ ÑÐ¾Ð¿Ð¾ÑÑÐ°Ð²Ð»ÐµÐ½Ñ Ñ Ð±Ð°Ð·Ð¾Ð¹. ÐÐ¸ÑÐµÐ³Ð¾ Ð½Ðµ Ð¸Ð¼Ð¿Ð¾ÑÑÐ¸ÑÑÐµÑ
const checkBitrixMark = (mark) => api.post(`/api/crm/cars/bitrixStock/check/${encodeURIComponent(mark)}`);

export default checkBitrixMark;
